export const lastClusterOfDigits = (input)=>{
    // Match all clusters of digits in the string
    const matches = input.match(/\d+/g);
    // Return the last match, or an empty string if no matches found
    return matches ? matches[matches.length - 1] : "";
};
export const slugify = (str)=>str ? str.toString().toLowerCase().replace(/\s+/g, '-') // Replace whitespace with dashes
    .replace(/[^\w\-]+/g, '') // Only keep a-z, A-Z, 0-9, underscores and dashes
    .replace(/\-\-+/g, '-') // Replace repeated dashes with a single dash
    .replace(/^-+/, '') // Trim dashes off of the beginning of the string
    .replace(/-+$/, '') // Trim dashes off of the end of the string
     : '';
export const capitalize = (s)=>s[0].toUpperCase() + s.slice(1);
export const isNullOrWhitespace = (input)=>!input || input.trim().length === 0;
export const notNullOrWhitespace = (input)=>!isNullOrWhitespace(input);
